import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

/**
 * Check if Google Analytics should be enabled
 * @returns {boolean} True if GA_MEASUREMENT_ID exists and we're in production
 */
export const isGAEnabled = () => {
  return Boolean(GA_MEASUREMENT_ID && GA_MEASUREMENT_ID.trim() !== '' && process.env.NODE_ENV === 'production');
};

/**
 * Initialize Google Analytics
 * Only initializes in production environment when Measurement ID is provided
 */
export const initGA = () => {
  if (isGAEnabled()) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
  }
};

/**
 * Log a page view
 * @param {string} path - The page path (e.g., '/leagues' or '/leagues/123')
 */
export const logPageView = (path) => {
  if (isGAEnabled()) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

/**
 * Log a custom event
 * @param {string} eventName - The event name (e.g., 'view_league', 'signup')
 * @param {object} eventParams - Event parameters
 * @param {string} eventParams.category - Event category (e.g., 'league', 'user')
 * @param {string} eventParams.label - Event label (optional)
 * @param {number} eventParams.value - Event value (optional)
 * @param {object} eventParams - Additional custom parameters
 */
export const logEvent = (eventName, eventParams = {}) => {
  if (isGAEnabled()) {
    ReactGA.event({
      action: eventName,
      category: eventParams.category || 'general',
      label: eventParams.label,
      value: eventParams.value,
      ...eventParams
    });
  }
};

/**
 * Set user properties (user ID, etc.)
 * @param {object} userProperties - User properties to set
 */
export const setUserProperties = (userProperties) => {
  if (isGAEnabled()) {
    ReactGA.set(userProperties);
  }
};

/**
 * Set user ID for tracking
 * @param {string} userId - User ID
 */
export const setUserId = (userId) => {
  if (isGAEnabled()) {
    ReactGA.set({ user_id: userId });
  }
};

